import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { removeLocaleFromPathname } from 'i18n/util/localeUrl'

export function useLocaleStrippedLocation() {
  const location = useLocation()
  return useMemo(() => {
    const stripped = removeLocaleFromPathname(location.pathname)
    return stripped === location.pathname ? location : { ...location, pathname: stripped }
  }, [location])
}
